(() => {
  if (customElements.get('product-ingredients-tabs')) return;

  class ProductIngredientsTabs extends HTMLElement {
    constructor() {
      super();
      this.onTriggerClick = this.onTriggerClick.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.product-ingredients-tabs__item'));
      this.triggers = Array.from(this.querySelectorAll('.product-ingredients-tabs__trigger'));
      this.section = this.closest('.product-ingredients-tabs');
      this.imageGrid = this.section?.querySelector('.product-ingredients-tabs__images-grid');
      this.imageItems = this.section
        ? Array.from(this.section.querySelectorAll('.product-ingredients-tabs__image-item'))
        : [];

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.onTriggerClick);
      });
    }

    disconnectedCallback() {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.onTriggerClick);
      });
    }

    onTriggerClick(event) {
      const trigger = event.currentTarget;
      const item = trigger.closest('.product-ingredients-tabs__item');
      const index = item?.dataset.index;

      if (!item || index === undefined) return;

      const isActive = item.classList.contains('product-ingredients-tabs__item--active');
      if (isActive) return;

      this.activateItem(parseInt(index, 10));
    }

    activateItem(index) {
      if (this.imageGrid) {
        this.imageGrid.dataset.activeIndex = index;
      }

      this.items.forEach((item, i) => {
        const panel = item.querySelector('.product-ingredients-tabs__panel');
        const trigger = item.querySelector('.product-ingredients-tabs__trigger');
        const isTarget = i === index;

        item.classList.toggle('product-ingredients-tabs__item--active', isTarget);
        trigger?.setAttribute('aria-expanded', String(isTarget));

        if (panel) {
          if (isTarget) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        }
      });

      this.imageItems.forEach((img, i) => {
        img.classList.toggle('product-ingredients-tabs__image-item--active', i === index);
      });
    }
  }

  customElements.define('product-ingredients-tabs', ProductIngredientsTabs);
})();
